import React, { useState, useEffect } from "react";
import { LoginForm } from "./components/LoginForm";
import { Dashboard } from "./components/Dashboard";
import { Toaster } from "./components/ui/sonner";
import { SidebarProvider } from "./components/ui/sidebar";

export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Check if user is already logged in on app load
  useEffect(() => {
    const checkAuthStatus = () => {
      const authToken = localStorage.getItem("authToken");
      setIsLoggedIn(!!authToken);
      setIsLoading(false);
    };

    checkAuthStatus();
  }, []);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 to-blue-50">
        <div className="text-center space-y-4">
          <img
            src="https://admin.coachable-app.com/images/logo.jpeg"
            alt="Coachable Logo"
            className="h-16 w-auto mx-auto rounded-lg shadow-lg"
          />
          <div className="w-8 h-8 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mx-auto" />
          <p className="text-muted-foreground">Loading Coachable...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {isLoggedIn ? (
        <SidebarProvider>
          {" "}
          {/* ✅ provider wraps Dashboard */}
          <Dashboard onLogout={handleLogout} />
        </SidebarProvider>
      ) : (
        <LoginForm onLoginSuccess={handleLoginSuccess} />
      )}
      <Toaster position="top-right" closeButton />
    </>
  );
}
